__turbopack_context__.v({
  "Grid": "Grid-module-scss-module__ReK4uG__Grid",
  "GridOf2": "Grid-module-scss-module__ReK4uG__GridOf2",
  "GridOf3": "Grid-module-scss-module__ReK4uG__GridOf3",
  "GridOf4": "Grid-module-scss-module__ReK4uG__GridOf4",
  "HasBorder": "Grid-module-scss-module__ReK4uG__HasBorder",
  "HasHoverEffect": "Grid-module-scss-module__ReK4uG__HasHoverEffect",
  "LargeGap": "Grid-module-scss-module__ReK4uG__LargeGap",
});
